const Menu = ({ menuPosition, onViewQuestions, onGoToSubClusters, onClose }) => (
  <div
  className="menu"
  style={{
    position: "absolute",
    // top: `${menuPosition.y}px`,
    // left: `${menuPosition.x}px`,
    zIndex: 1000,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "10px",
    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
  }}
>
<button onClick={onViewQuestions} className="btn btn-sm btn-primary mb-2">
      View Questions
    </button>
    <button onClick={onGoToSubClusters} className="btn btn-sm btn-secondary mb-2">
      Go to Subclusters
    </button>
    <button onClick={onClose} className="btn btn-sm btn-danger">
      Cancel
    </button>
</div>

  );

export default Menu;